import { createSlice } from "@reduxjs/toolkit";
import { AppStorageKeys } from "../Constants/Constants";
import SessionStorage from "../Constants/SessionStorage";

const initialState = {
  favoriteDevicesFlag: !!SessionStorage.get(AppStorageKeys.favDevices),
};

const commonStore = createSlice({
  name: "common",
  initialState,
  reducers: {
    setFavoriteDevicesFlag: (state, action) => {
      const flag = action.payload;
      state.favoriteDevicesFlag = flag;
      if (flag) {
        SessionStorage.set(AppStorageKeys.favDevices, true);
      } else {
        SessionStorage.remove(AppStorageKeys.favDevices);
      }
    },
  },
});

export const { setFavoriteDevicesFlag } = commonStore.actions;

export default commonStore.reducer;
